import React, { FC, useEffect, useState } from 'react';

import { getRolesListFetch } from 'src/resources/rolesList/reducer';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import translate from '@translate';
import { setLocationParams } from 'src/resources/location/reducer';
import TableSimple from 'src/components/TableSimple';
import { allColumns } from './constants';
import { TableRowType } from 'src/types/table';
import { useCheckPermission } from 'src/utils/checkPermission';
import TopBlock from './TopBlock';
import { getEmailTemplatesListFetch } from 'src/resources/emailTemplates/reducer';
import { useNavigate } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch';
export interface RolesListContainerPropsType {
}

const EmailTemplatesContainer: FC<RolesListContainerPropsType> = (props) => {
    const dispatch = useDispatch();

    const loading = useSelector((state: RootStoreType) => state.emailTemplatesList.loading);
    const emailTemplatesData = useSelector((state: RootStoreType) => state.emailTemplatesList.data);

    const [emailTemplatesList, setEmailTemplatesList] = useState<TableRowType[]>([]);

    const permissionCreate = useCheckPermission('EMAIL_TEMPLATE.CREATE');
    const permissionDetail = useCheckPermission('EMAIL_TEMPLATE.DETAIL');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('emailTemplates.title') }));
    }, []);

    useEffect(() => {
        if (!emailTemplatesData) {
            dispatch(getEmailTemplatesListFetch());
        } else {
            setEmailTemplatesList(emailTemplatesData);
        }
    }, [emailTemplatesData]);

    const reloadList = () => {
        dispatch(getEmailTemplatesListFetch());
    };

    return (
        <>
            <TopBlock reloadList={reloadList} permissionCreate={permissionCreate} />
            <TableSimple
                rowIdKey='ID'
                rows={emailTemplatesList}
                loading={loading}
                columsLabelPrefix='emailTemplates.table'
                allColumns={allColumns}
                initSort={{ column: 'ID', direction: 'DESC' }}
                rowActions={[
                    {
                        icon: <LaunchIcon />,
                        label: translate('emailTemplates.emailTemplateDetail'),
                        getLink: (row) => `/admin/email_templates/${row.ID}/`,
                        hiddenFce: () => !permissionDetail,
                    },
                ]}
                heightVariant='top-tab'
                fullHeight
                optionsSessionName='emailTemplatesTable'
            />
        </>
    );
};

export default EmailTemplatesContainer;
